import React, { useState, useEffect } from 'react';
import '../scss/dashboard.scss';
import Header from '../components/header';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import BaseURL from '../assets/contants/BaseURL';
import Chart from 'react-apexcharts';
import moment from 'moment';
import ExcelJS from 'exceljs';

const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];


const ActualReadingportal = () => {

    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedNewYear, setSelectedNewYear] = useState(new Date().getFullYear());
    const [chartsData, setChartsData] = useState({
        categories: [],
        t1: [],
        t2: [],
        t3: [],
        t4: [],
        t5: [],
        t: []
    });

    const [readings, setReadings] = useState({
        today: { t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, t: 0 },
        yesterday: { t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, t: 0 },
        current_month: { t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, t: 0 },
        last_month: { t1: 0, t2: 0, t3: 0, t4: 0, t5: 0, t: 0 }
    });

    useEffect(() => {
        fetchReadings();
    }, []);

    const fetchReadings = async () => {
        try {
            const today = new Date();
            const dateStr = today.toISOString().split('T')[0];

            const response = await axios.post(`${BaseURL}meters/readings-summary/`, {
                date: dateStr
            });

            setReadings({
                today: response.data.today,
                yesterday: response.data.yesterday,
                current_month: response.data.current_month,
                last_month: response.data.last_month
            });
        } catch (err) {
            console.error('Error fetching readings:', err);
        }
    };

    const formatNumber = (num) => {
        return num ? num.toFixed(0) : '0';
    };

    const handleMonthChange = (e) => setSelectedMonth(parseInt(e.target.value));
    const handleYearChange = (e) => setSelectedYear(parseInt(e.target.value));
    const handleNewYearChange = (e) => {
        const year = parseInt(e.target.value);
        setSelectedNewYear(year);
    };

    const [chartData, setChartData] = useState({
        categories: [],
        t1: [],
        t2: [],
        t3: [],
        t4: [],
        t5: [],
        t: []
    });

    useEffect(() => {
        fetchChartData();
    }, [selectedMonth, selectedYear]);

    const fetchChartData = async () => {
        try {

            const response = await axios.post(`${BaseURL}meters/readings-bar-chart/`, {
                month: selectedMonth,
                year: selectedYear
            });

            const data = response.data;

            const categories = data.chart_data.map(item => item.date);

            setChartData({
                categories: categories,
                t1: data.chart_data.map(item => item.t1),
                t2: data.chart_data.map(item => item.t2),
                t3: data.chart_data.map(item => item.t3),
                t4: data.chart_data.map(item => item.t4),
                t5: data.chart_data.map(item => item.t5),
                t: data.chart_data.map(item => item.t)
            });
        } catch (err) {
            console.error('Error fetching chart data:', err);
        }
    };

    const fetchMonthlyData = async (year) => {
        try {
            const response = await axios.post(`${BaseURL}meters/readings-monthly-bar-chart/`, {
                year: year
            });

            const data = response.data;

            const categories = data.monthly_data.map(item => item.month_name);
            const t1 = data.monthly_data.map(item => item.slot_totals.t1);
            const t2 = data.monthly_data.map(item => item.slot_totals.t2);
            const t3 = data.monthly_data.map(item => item.slot_totals.t3);
            const t4 = data.monthly_data.map(item => item.slot_totals.t4);
            const t5 = data.monthly_data.map(item => item.slot_totals.t5);
            const t = data.monthly_data.map(item => item.slot_totals.t);

            setChartsData({
                categories,
                t1,
                t2,
                t3,
                t4,
                t5,
                t
            });
        } catch (error) {
            console.error("Error fetching monthly data:", error);
        }
    };

    useEffect(() => {
        fetchMonthlyData(selectedNewYear);
    }, [selectedNewYear]);

    const [activeTab, setActiveTab] = useState("Daily");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [dailyloading, setDailyLoading] = useState(false);
    const [dailyreportData, setDailyreportData] = useState([]);
    const [currentdailyreportPage, setCurrentdailyreportPage] = useState(1);
    const [monthlyloading, setMonthlyLoading] = useState(false);
    const [monthlyfromDate, setmonthlyFromDate] = useState(null);
    const [monthlytoDate, setmonthlyToDate] = useState(null);
    const [currentmonthlyreportPage, setCurrentmonthlyreportPage] = useState(1);
    const [monthsData, setMonthsData] = useState([]);
    const [totals, setTotals] = useState({
        total_slot_t1: 0,
        total_slot_t2: 0,
        total_slot_t3: 0,
        total_slot_t4: 0,
        total_slot_t5: 0,
        total_slot_t: 0
    });

    const tabs = ["Daily", "Monthly"];

    const handleTabChange = (tab) => {
        setActiveTab(tab);

        if (tab !== "Daily") {
            setDailyreportData([]);
            setFromDate(0);
            setToDate(0);
            setCurrentdailyreportPage(1);
        }
        if (tab !== "Monthly") {
            setMonthsData([]);
            setmonthlyFromDate(0);
            setmonthlyToDate(0);
            setCurrentmonthlyreportPage(1);
        }
    };

    const handleGetDailyReport = async () => {
        if (!fromDate || !toDate) {
            alert("Please select both date range");
            return;
        }

        setDailyLoading(true);
        try {
            const startDate = moment(fromDate).format("YYYY-MM-DD");
            const endDate = moment(toDate).format("YYYY-MM-DD");

            const response = await axios.post(`${BaseURL}meters/readings-daily-report/`, {
                from_date: startDate,
                to_date: endDate
            });

            setDailyreportData(response.data);
        } catch (error) {
            console.error("Error fetching daily report:", error);
            alert("Failed to fetch daily report data");
            setDailyreportData(null);
        } finally {
            setDailyLoading(false);
        }
    };

    const rowsdailyPerPage = 10;
    const totaldailyPages = dailyreportData?.daily_readings ? Math.ceil(dailyreportData.daily_readings.length / rowsdailyPerPage) : 0;
    const indexOfdailyLastRow = currentdailyreportPage * rowsdailyPerPage;
    const indexOfdailyFirstRow = indexOfdailyLastRow - rowsdailyPerPage;
    const currentDailyRows = dailyreportData?.daily_readings?.slice(indexOfdailyFirstRow, indexOfdailyLastRow) || [];
    

    const handledailyPageChange = (newPage) => {
        setCurrentdailyreportPage(newPage);
    };

    const fetchMonthlyReport = async () => {
        if (!monthlyfromDate || !monthlytoDate) {
            alert("Please select both date range");
            return;
        }

        setMonthlyLoading(true);
        try {
            const fromMonthYear = `${monthlyfromDate.getFullYear()}-${(monthlyfromDate.getMonth() + 1).toString().padStart(2, '0')}`;
            const toMonthYear = `${monthlytoDate.getFullYear()}-${(monthlytoDate.getMonth() + 1).toString().padStart(2, '0')}`;

            const response = await axios.post(`${BaseURL}meters/readings-monthly-report/`, {
                from_month_year: fromMonthYear,
                to_month_year: toMonthYear
            });

            const transformedData = response.data.months.map((month, index) => ({
                id: index + 1,
                month: month,
                slot_t1: response.data.columns[0].data[index],
                slot_t2: response.data.columns[1].data[index],
                slot_t3: response.data.columns[2].data[index],
                slot_t4: response.data.columns[3].data[index],
                slot_t5: response.data.columns[4].data[index],
                slot_t: response.data.columns[5].data[index]
            }));

            setMonthsData(transformedData);
            setTotals({
                total_slot_t1: response.data.total_slot_t1,
                total_slot_t2: response.data.total_slot_t2,
                total_slot_t3: response.data.total_slot_t3,
                total_slot_t4: response.data.total_slot_t4,
                total_slot_t5: response.data.total_slot_t5,
                total_slot_t: response.data.total_slot_t
            });
        } catch (error) {
            console.error("Error fetching monthly report:", error);
            alert("Failed to fetch monthly report data");
        } finally {
            setMonthlyLoading(false);
        }
    };

    const rowsmonthlyPerPage = 10;
    const totalmonthlyPages = Math.ceil(monthsData.length / rowsmonthlyPerPage);
    const indexOfmonthlyLastRow = currentmonthlyreportPage * rowsmonthlyPerPage;
    const indexOfmonthlyFirstRow = indexOfmonthlyLastRow - rowsmonthlyPerPage;
    const currentMonthlyRows = monthsData.slice(indexOfmonthlyFirstRow, indexOfmonthlyLastRow);

    const handlemonthlyPageChange = (newPage) => {
        setCurrentmonthlyreportPage(newPage);
    };

    const handleMonthlyFromMonthChange = (date) => {
        setmonthlyFromDate(date);
    };

    const handleMonthlyToMonthChange = (date) => {
        setmonthlyToDate(date);
    };

    const formatDateForDisplay = (dateString) => {
        return moment(dateString).format("YYYY-MM-DD");
    };

    const handleDailyExportToExcel = async () => {
        if (!fromDate || !toDate) {
            alert("Please select both date range");
            return;
        }

        if (!dailyreportData || !dailyreportData.daily_readings || dailyreportData.daily_readings.length === 0) {
            alert("No data available to export.");
            return;
        }

        const fromDateTime = new Date(fromDate);
        const toDateTime = new Date(toDate);

        const formattedFromDate = fromDateTime.toISOString().split('T')[0];
        const formattedToDate = toDateTime.toISOString().split('T')[0];

        const fileName = `Daily_Readings_${formattedFromDate}_to_${formattedToDate}.xlsx`;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Daily Readings');

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 7; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(7 / 2) - 1;

            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        worksheet.getColumn(1).width = 20;
        for (let i = 2; i <= 7; i++) {
            worksheet.getColumn(i).width = 15;
        }

        const dateRow = worksheet.addRow([`From Date: ${moment(fromDate).format("YYYY-MM-DD")}, To Date: ${moment(toDate).format("YYYY-MM-DD")}`]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 7);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
        dateRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const titleRow = worksheet.addRow(['Daily Actual Readings']);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 7);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const headers = ['Date', 'T1', 'T2', 'T3', 'T4', 'T5', 'Total'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        dailyreportData.daily_readings.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                formatDateForDisplay(row.date),
                row.t1.toFixed(2),
                row.t2.toFixed(2),
                row.t3.toFixed(2),
                row.t4.toFixed(2),
                row.t5.toFixed(2),
                row.t.toFixed(2)
            ]);

            dataRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
        });

        const totalRow = worksheet.addRow([
            'TOTAL',
            dailyreportData.totals?.total_t1?.toFixed(2) || '0.00',
            dailyreportData.totals?.total_t2?.toFixed(2) || '0.00',
            dailyreportData.totals?.total_t3?.toFixed(2) || '0.00',
            dailyreportData.totals?.total_t4?.toFixed(2) || '0.00',
            dailyreportData.totals?.total_t5?.toFixed(2) || '0.00',
            dailyreportData.totals?.total_t?.toFixed(2) || '0.00'
        ]);
        
        totalRow.font = { bold: true };
        totalRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFEB3B' },
            };
            cell.alignment = { horizontal: 'right' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const handleMonthlyExportToExcel = async () => {
        if (!monthlyfromDate || !monthlytoDate) {
            alert("Please select both date range");
            return;
        }

        if (!monthsData || monthsData.length === 0) {
            alert("No data available to export.");
            return;
        }

        const fromMonth = monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
        const toMonth = monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });

        const fileName = `Monthly_Readings_${fromMonth}_to_${toMonth}.xlsx`.replace(/ /g, '_');
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Monthly Readings');

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 8; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(8 / 2) - 1;

            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        worksheet.getColumn(1).width = 8;
        worksheet.getColumn(2).width = 15;
        for (let i = 3; i <= 8; i++) {
            worksheet.getColumn(i).width = 12;
        }

        const dateRow = worksheet.addRow([`From: ${fromMonth}, To: ${toMonth}`]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 8);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
        dateRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const titleRow = worksheet.addRow(['Monthly Meter Readings']);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 8);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const headers = ['S.No', 'Month', 'T1', 'T2', 'T3', 'T4', 'T5', 'Total'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        monthsData.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                row.id,
                row.month,
                row.slot_t1.toFixed(2),
                row.slot_t2.toFixed(2),
                row.slot_t3.toFixed(2),
                row.slot_t4.toFixed(2),
                row.slot_t5.toFixed(2),
                row.slot_t.toFixed(2)
            ]);

            dataRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
        });

        const totalRow = worksheet.addRow([
            '',
            'TOTAL',
            totals.total_slot_t1.toFixed(2),
            totals.total_slot_t2.toFixed(2),
            totals.total_slot_t3.toFixed(2),
            totals.total_slot_t4.toFixed(2),
            totals.total_slot_t5.toFixed(2),
            totals.total_slot_t.toFixed(2)
        ]);
        
        totalRow.font = { bold: true };
        totalRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFEB3B' },
            };
            cell.alignment = { horizontal: 'right' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const getBase64FromImageUrl = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    return (
        <div className="dashboard-container">
            <Header title="BRADKEN TOD READINGS DASHBOARD" />
            <div className="card-container" style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginTop: '50px',
                maxWidth: '1000px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }}>
                <h3 className="dashboard-subtitle">Actual Readings</h3>
                <div className="widgets-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '20px' }}>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Today's</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}>T1</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{formatNumber(readings.today.t1)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}>T2</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{formatNumber(readings.today.t2)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}>T3</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{formatNumber(readings.today.t3)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}>T4</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{formatNumber(readings.today.t4)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}>T5</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{formatNumber(readings.today.t5)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}>T</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{formatNumber(readings.today.t)}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #4caf50, #2b9e36)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Yesterday</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T1</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.yesterday.t1)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T2</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.yesterday.t2)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T3</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.yesterday.t3)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T4</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.yesterday.t4)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T5</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.yesterday.t5)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.yesterday.t)}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #2196f3, #0b7dda)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Current Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T1</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.current_month.t1)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T2</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.current_month.t2)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T3</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.current_month.t3)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T4</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.current_month.t4)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T5</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.current_month.t5)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.current_month.t)}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #ed76fd, #e53afd)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Last Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T1</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.last_month.t1)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T2</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.last_month.t2)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T3</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.last_month.t3)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T4</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.last_month.t4)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T5</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.last_month.t5)}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>T</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>{formatNumber(readings.last_month.t)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="charts-container"
                    style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}
                >
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#fbe9f6',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Day's Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Month:
                            </label>
                            <select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                style={{
                                    padding: "5px",
                                    marginRight: "20px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {monthNames.map((month, index) => (
                                    <option key={index + 1} value={index + 1}>
                                        {month}
                                    </option>
                                ))}
                            </select>

                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedYear}
                                onChange={handleYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    background: '#fbe9f6',
                                    toolbar: {
                                        show: true,
                                        tools: {
                                            zoom: false,
                                            zoomin: false,
                                            zoomout: false,
                                            pan: false,
                                            reset: false,
                                            download: false,
                                        },
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '80%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#FF66C3'],
                                dataLabels: {
                                    enabled: false,
                                },
                                stroke: {
                                    show: true,
                                    width: 2,
                                    colors: ['transparent']
                                },
                                xaxis: {
                                    categories: chartData.categories,
                                    title: {
                                        text: 'Dates',
                                    },
                                    labels: {
                                        rotate: -45,
                                        style: {
                                            fontSize: '12px'
                                        }
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Value',
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return value.toFixed(0);
                                        },
                                    },
                                },
                                legend: {
                                    position: 'top',
                                    horizontalAlign: 'center',
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value) {
                                            return value.toFixed(0);
                                        }
                                    }
                                },
                                fill: {
                                    opacity: 1
                                },
                            }}
                            series={[
                                {
                                    name: 'T1',
                                    data: chartData.t1
                                },
                                {
                                    name: 'T2',
                                    data: chartData.t2
                                },
                                {
                                    name: 'T3',
                                    data: chartData.t3
                                },
                                {
                                    name: 'T4',
                                    data: chartData.t4
                                },
                                {
                                    name: 'T5',
                                    data: chartData.t5
                                },
                                {
                                    name: 'T',
                                    data: chartData.t
                                }
                            ]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f0fbff',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Monthly Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedNewYear}
                                onChange={handleNewYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    toolbar: {
                                        show: true,
                                        tools: {
                                            zoom: false,
                                            zoomin: false,
                                            zoomout: false,
                                            pan: false,
                                            reset: false,
                                            download: false,
                                        },
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '80%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#FF66C3'],
                                dataLabels: {
                                    enabled: false,
                                },
                                stroke: {
                                    show: true,
                                    width: 2,
                                    colors: ['transparent']
                                },
                                xaxis: {
                                    categories: chartsData.categories,
                                    title: {
                                        text: 'Months',
                                    },
                                    labels: {
                                        rotate: -45,
                                        style: {
                                            fontSize: '12px'
                                        }
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Value',
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return value.toFixed(0);
                                        },
                                    },
                                },
                                legend: {
                                    position: 'top',
                                    horizontalAlign: 'center',
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value) {
                                            return value.toFixed(0);
                                        }
                                    }
                                },
                                fill: {
                                    opacity: 1
                                },
                            }}
                            series={[
                                {
                                    name: 'T1',
                                    data: chartsData.t1
                                },
                                {
                                    name: 'T2',
                                    data: chartsData.t2
                                },
                                {
                                    name: 'T3',
                                    data: chartsData.t3
                                },
                                {
                                    name: 'T4',
                                    data: chartsData.t4
                                },
                                {
                                    name: 'T5',
                                    data: chartsData.t5
                                },
                                {
                                    name: 'T',
                                    data: chartsData.t
                                }
                            ]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div className="dashboard">
                    <div className="main-container">
                        <h4>Reports</h4>
                        <div className="nav-bar">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={activeTab === tab ? "active" : ""}
                                    onClick={() => handleTabChange(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        {activeTab === "Daily" && (
                            <div className="daily-report-production">
                                <div className="card controls-card">
                                    <input
                                        type="date"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                        placeholder="Select Date"
                                    />
                                    <input
                                        type="date"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                        placeholder="Select Date"
                                    />
                                    <button onClick={handleGetDailyReport}>Get Report</button>
                                    <button
                                    onClick={() => {
                                        const fileName = `Daily_Report_${fromDate}_to_${toDate}.xlsx`;
                                        handleDailyExportToExcel(dailyreportData, fileName);
                                    }}
                                    >
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                {dailyloading ? (
                                    <span className="spinner" />
                                ) : (
                                    <div className="table-container">
                                        <h4 className="table-title">
                                            Daily Log View from {fromDate ? moment(fromDate).format("YYYY-MM-DD HH:mm") : "Selected from Date"}
                                            to {toDate ? moment(toDate).format("YYYY-MM-DD HH:mm") : "Selected to date"}
                                        </h4>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>T1</th>
                                                    <th>T2</th>
                                                    <th>T3</th>
                                                    <th>T4</th>
                                                    <th>T5</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentDailyRows.length > 0 ? (
                                                    currentDailyRows.map((row, index) => (
                                                        <tr key={index}>
                                                            <td>{formatDateForDisplay(row.date)}</td>
                                                            <td>{row.t1.toFixed(0)}</td>
                                                            <td>{row.t2.toFixed(0)}</td>
                                                            <td>{row.t3.toFixed(0)}</td>
                                                            <td>{row.t4.toFixed(0)}</td>
                                                            <td>{row.t5.toFixed(0)}</td>
                                                            <td>{row.t.toFixed(0)}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" style={{ textAlign: "center" }}>
                                                            No Data Available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="1" style={{ textAlign: "right" }}>TOTAL</td>
                                                    <td>{dailyreportData?.totals?.total_t1?.toFixed(0) || '0.00'}</td>
                                                    <td>{dailyreportData?.totals?.total_t2?.toFixed(0) || '0.00'}</td>
                                                    <td>{dailyreportData?.totals?.total_t3?.toFixed(0) || '0.00'}</td>
                                                    <td>{dailyreportData?.totals?.total_t4?.toFixed(0) || '0.00'}</td>
                                                    <td>{dailyreportData?.totals?.total_t5?.toFixed(0) || '0.00'}</td>
                                                    <td>{dailyreportData?.totals?.total_t?.toFixed(0) || '0.00'}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                )}
                                <div className="pagination-controls">
                                    <button
                                        disabled={currentdailyreportPage === 1 || currentDailyRows.length === 0}
                                        onClick={() => handledailyPageChange(currentdailyreportPage - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span>  {currentdailyreportPage}   of   {totaldailyPages}  </span>
                                    <button
                                        disabled={currentdailyreportPage === totaldailyPages || currentDailyRows.length === 0}
                                        onClick={() => handledailyPageChange(currentdailyreportPage + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                        {activeTab === "Monthly" && (
                            <div className="Monthly-Report">
                                <div className="card controls-card">
                                    <DatePicker
                                        selected={monthlyfromDate}
                                        onChange={handleMonthlyFromMonthChange}
                                        dateFormat="yyyy-MM"
                                        showMonthYearPicker
                                        placeholderText="Select From Month"
                                        className="custom-date-picker"
                                    />

                                    <DatePicker
                                        selected={monthlytoDate}
                                        onChange={handleMonthlyToMonthChange}
                                        dateFormat="yyyy-MM"
                                        showMonthYearPicker
                                        placeholderText="Select To Month"
                                        className="custom-date-picker"
                                    />
                                    <button onClick={fetchMonthlyReport}>Get Report</button>
                                    <button onClick={handleMonthlyExportToExcel}>
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                {monthlyloading ? (
                                    <div>
                                        <span className="spinner"></span>
                                    </div>
                                ) : (
                                    <div className="table-container">
                                        <h4 className="table-title">Monthly Readings from {monthlyfromDate ? monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected from Month"} to {monthlytoDate ? monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected to Month"}</h4>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Month</th>
                                                    <th>T1</th>
                                                    <th>T2</th>
                                                    <th>T3</th>
                                                    <th>T4</th>
                                                    <th>T5</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentMonthlyRows.length > 0 ? (
                                                    currentMonthlyRows.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.id}</td>
                                                            <td>{item.month}</td>
                                                            <td>{item.slot_t1.toFixed(0)}</td>
                                                            <td>{item.slot_t2.toFixed(0)}</td>
                                                            <td>{item.slot_t3.toFixed(0)}</td>
                                                            <td>{item.slot_t4.toFixed(0)}</td>
                                                            <td>{item.slot_t5.toFixed(0)}</td>
                                                            <td>{item.slot_t.toFixed(0)}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" style={{ textAlign: "center" }}>
                                                            No Data Available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="2" style={{ textAlign: "right" }}>TOTAL</td>
                                                    <td>{totals.total_slot_t1.toFixed(0)}</td>
                                                    <td>{totals.total_slot_t2.toFixed(0)}</td>
                                                    <td>{totals.total_slot_t3.toFixed(0)}</td>
                                                    <td>{totals.total_slot_t4.toFixed(0)}</td>
                                                    <td>{totals.total_slot_t5.toFixed(0)}</td>
                                                    <td>{totals.total_slot_t.toFixed(0)}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                )}
                                <div className="pagination-controls">
                                    <button
                                        disabled={currentmonthlyreportPage === 1 || currentMonthlyRows.length === 0}
                                        onClick={() => handlemonthlyPageChange(currentmonthlyreportPage - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span>  {currentmonthlyreportPage}   of   {totalmonthlyPages}  </span>
                                    <button
                                        disabled={currentmonthlyreportPage === totalmonthlyPages || currentMonthlyRows.length === 0}
                                        onClick={() => handlemonthlyPageChange(currentmonthlyreportPage + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActualReadingportal;
